import { SendScreeningToolFeedbackDto } from "@abbvie-epi/common/dto";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";

@Injectable({
    providedIn: "root"
})
export class MailService {
    constructor(private readonly http: HttpClient) {}

    public sendResultsEmail(dto: SendScreeningToolFeedbackDto) {
        return this.http.post(`${environment.apiHost}/api/mail/screening-tool-feedback`, dto);
    }
}
